module.exports = __webpack_public_path__ + "static/statusquo-cdf865ee40101b3066b2f25c94609f75.jpg";